import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import { links } from "../../functions/links";
import Tabla_creditos from "../creditos/tablas/Tabla_creditos";
import { Spinner, ConcesionesContext, clienteAxios, useHistory } from "../shared/";
import { BotonAgregar } from "../shared/Estilos";
import { Input } from "../shared/FormsElements";
import ListarConcesiones from "./ListarConcesiones";
import Tabla_concesiones from "./tablas/Tabla_concesiones";
import "../shared/styles/ViewContainer.css";

const Concesiones = (props) => {
  const concesionesContext = useContext(ConcesionesContext);
  const { cargando, obtener } = concesionesContext;

  const history = useHistory();
  const [concesiones, setConcesiones] = useState(null);


  const [DatosForm, LeerForm] = useState({
    buscar: "",

    page: 1,
    paginator: 10
  });

  const [params, setParams] = useState({
    texto: "",

    concesion: "true",
    page: 1,
    paginator: 30
  })
  //state
  const [creditos, setCreditos] = useState(null)

  const { buscar } = DatosForm;

  //Eventos
  const onClick = (e, value) => {
    switch (e.target.name) {
      case "ver_credito":
        history.push("/creditos/ver/" + value.id);
        break;
      case "delete_concesion":{
        Swal.fire({
          title: "Eliminar credito",
          html:
            "<p>¿Quieres dar de baja la siguiente concesion?</p>" +
            '<ul class="list-group"><li class="list-group-item border-0 d-flex justify-content-between"><div>Nº de Concesion '+ value.id +'</div></li><li class="list-group-item border-0 d-flex justify-content-center "><div>Contraseña de adminsitrador </div></li><ul>' 
           ,
          input: "password",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
          preConfirm: async (result) => {
            
            let formData = new FormData();
            formData.append("id", value.id);
            formData.append("status", 'Eliminado');
            formData.append("password", result);
            
            const response = await clienteAxios({
              method: "post",
              url: "/Concesion/darBaja",
              data: formData,
            }).then((result) => {
                Swal.fire({
                  title: 'Concesion Eliminado!',
                  text: 'El credito se elimino correctamente',
                });

                return window.location.reload();
              })
              .catch((result) => {
                return Swal.showValidationMessage(
                  `Request failed: ${result.response.data.messages.msg}`
                );
              });
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          console.log("ok");
        });
      } break;
      case "anterior": {
        if (params.page !== 1) {
          setParams({
            ...params,
            page: params.page - 1
          })
        }
      } break;
      case "siguiente": {
        setParams({
          ...params,
          page: params.page + 1
        })
      } break;
    }
  }

  const onChange = (e) => {
    setParams({
      ...params,
      [e.target.name]: e.target.value,
    });

    /*
    if (buscar.length > 1) {
      obtener(buscar);
    }
    */
  };

  useEffect(() => {
    const obtenerCreditos = async () => {
      try {
        const result = await clienteAxios.get(
          "/PersonaCreditos/getAll",
          { params }
        );

        let creditos = [];

        result.data.creditos.map((credito) => {
          if (credito.concesion) {
            creditos.push(credito);
          }
        })

        setCreditos(
          result.data //.filter((result) => result.id_credito === null)
        );
        /*  console.log(result.data.creditos.filter(
          (result) => result.id_credito === null
        )); */
      } catch (e) { }
    };

    obtenerCreditos();
  }, [params])

  useEffect(() => {
    const fetch = async () => {
      try {
        const result = await clienteAxios.get(
          "/Concesion/getAll",
          { params }
        );

        setConcesiones(result.data)

        /*  console.log(result.data.creditos.filter(
          (result) => result.id_credito === null
        )); */
      } catch (e) { }
    }

    fetch()
  }, [params])

  /*
  useEffect(() => {
    // eslint-disable-next-line
    obtener(buscar);
  }, [buscar]);
  */

  //Logs
  console.log(concesiones);
  return (
    <div className="view-container">
      <div className="view-header">
        <h3 className="view-title">GESTIONAR CONCESIONES</h3>
        <div className="view-actions">
          <button
            onClick={() => {
              props.history.push("/concesiones/nuevo");
            }}
            className="btn-add-primary"
          >
            <i className="bi bi-plus-lg me-2"></i>
            Agregar Concesión
          </button>
        </div>
      </div>

      <div className="view-search">
        <div className="search-group">
          <i className="bi bi-search search-icon"></i>
          <input
            type="text"
            className="search-input"
            placeholder="Buscar concesión..."
            name="texto"
            value={params.texto}
            onChange={onChange}
          />
        </div>
      </div>

      <div className="view-content">

        {concesiones ? (
          <div>
            <div className="pagination-container fade-in">
              <div className="pagination-info">
                Total: {concesiones.registros} registros
              </div>
              <div className="pagination-buttons">
                <button
                  className="pagination-btn"
                  name="anterior"
                  onClick={(event) => onClick(event)}
                  disabled={concesiones.pagina === 1}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                {concesiones.pagina !== 1 && (
                  <button
                    className="pagination-btn"
                    name="link"
                    onClick={(event) => onClick(event, 1)}
                  >
                    1
                  </button>
                )}
                {concesiones.pagina > 2 && <span className="pagination-ellipsis">...</span>}
                <button className="pagination-btn pagination-btn-active">
                  {concesiones.pagina}
                </button>
                {links(concesiones.pagina, concesiones.paginas).map((link, index) => (
                  <button
                    key={index}
                    className="pagination-btn"
                    name="link"
                    onClick={(event) => onClick(event, link)}
                  >
                    {link}
                  </button>
                ))}
                {concesiones.pagina < concesiones.paginas - 1 && (
                  <span className="pagination-ellipsis">...</span>
                )}
                {concesiones.pagina !== concesiones.paginas && (
                  <button
                    className="pagination-btn"
                    name="link"
                    onClick={(event) => onClick(event, concesiones.paginas)}
                  >
                    {concesiones.paginas}
                  </button>
                )}
                <button
                  className="pagination-btn"
                  name="siguiente"
                  onClick={(event) => onClick(event)}
                  disabled={concesiones.pagina === concesiones.paginas}
                >
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>

            <Tabla_concesiones
              data={concesiones.concesiones}
              onClick={onClick}
              onChange={onChange}
            />
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </div>
  );
};

export default Concesiones;
